import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { SiemProtocol } from '@kirin/api-client/contracts/settings';

interface SiemNoteBoxProps {
  /** Active transport; when HEC, the copy explains the HEC path instead of syslog. */
  protocol?: SiemProtocol;
}

export function SiemNoteBox({ protocol }: SiemNoteBoxProps = {}) {
  const isHec = protocol === SiemProtocol.Hec;
  return (
    <Alert>
      <AlertTitle className="inline font-semibold text-foreground">
        Note:
      </AlertTitle>{' '}
      <AlertDescription className="inline text-foreground/80">
        {isHec
          ? 'Events are POSTed to your Splunk HTTP Event Collector (HEC) endpoint over HTTPS with the token as a bearer credential. Use HEC for Splunk Cloud, which does not accept raw syslog. Ensure HEC is enabled and the token is valid.'
          : 'Events are sent in RFC 3164 and RFC 5424 format. Ensure your SIEM is configured to accept connections on the specified protocol and port. For Splunk Cloud, use the HEC protocol instead of a syslog forwarder.'}
      </AlertDescription>
    </Alert>
  );
}
